import { myFetch } from "./fetch-config";

const scannerApi = "/scanner";

// ========== ERC20 相关接口 ==========

/**
 * 1. 查询合约列表
 * @param {number} page - 页码，默认1
 * @param {number} size - 每页数量，默认20
 * @returns {Promise}
 */
export function getContracts(page = 1, size = 20) {
    const url = `${scannerApi}/evmapi/contracts?page=${page}&size=${size}`;
    return myFetch(null, url, { method: "GET" });
}

/**
 * 2. 查询ERC20 Token列表
 * @param {number} page - 页码，默认1
 * @param {number} size - 每页数量，默认20
 * @returns {Promise}
 */
export function getTokens(page = 1, size = 20, symbol = '', address = '') {
    const sym = encodeURIComponent(symbol == null ? '' : String(symbol));
    let url = `${scannerApi}/evmapi/tokens?page=${page}&size=${size}&symbol=${sym}`;
    if (address) {
        url += `&address=${encodeURIComponent(address)}`;
    }
    return myFetch(null, url, { method: "GET" });
}

/**
 * 3. 查询ERC20代币详情
 * @param {string} address - ERC20代币合约地址
 * @returns {Promise}
 */
export function getTokenDetail(address) {
    const url = `${scannerApi}/evmapi/tokens/${address}`;
    return myFetch(null, url, { method: "GET" });
}

/**
 * 4. 查询ERC20的Transfer记录
 * @param {string} address - ERC20代币合约地址
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码，默认1
 * @param {number} params.size - 每页数量，默认20
 * @param {string} params.from - 发送方地址（可选）
 * @param {string} params.to - 接收方地址（可选）
 * @returns {Promise}
 */
export function getTokenTransfers(address, params = {}) {
    const { page = 1, size = 20, from, to } = params;
    let url = `${scannerApi}/evmapi/tokens/${address}/transfers?page=${page}&size=${size}`;
    if (from) {
        url += `&from=${from}`;
    }
    if (to) {
        url += `&to=${to}`;
    }
    return myFetch(null, url, { method: "GET" });
}

/**
 * 5. 查询指定合约的交易记录
 * @param {string} address - 合约地址
 * @param {number} page - 页码，默认1
 * @param {number} size - 每页数量，默认20
 * @returns {Promise}
 */
export function getContractTransactions(address, page = 1, size = 20) {
    const url = `${scannerApi}/evmapi/contracts/${address}/transactions?page=${page}&size=${size}`;
    return myFetch(null, url, { method: "GET" });
}

/**
 * 6. 交易解析 - 解析并获取单笔EVM交易的详细动作
 * @param {string} txHash - 交易哈希
 * @returns {Promise}
 */
export function getTransactionAnalysis(txHash) {
    const url = `${scannerApi}/evmapi/transactions/${txHash}/analysis`;
    return myFetch(null, url, { method: "GET" });
}

/**
 * 7. 按用户地址查 ERC20 持仓列表
 * @param {string} address - 用户地址
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码，默认1
 * @param {number} params.size - 每页数量，默认20
 * @param {string|number} params.min_balance - 最小余额（可选，筛选大于此余额的token）
 * @returns {Promise}
 */
export function getAccountERC20Balances(address, params = {}) {
    const { page = 1, size = 20, min_balance = 0.001 } = params;
    let url = `${scannerApi}/evmapi/accounts/${address}/erc20-balances?page=${page}&size=${size}`;
    if (min_balance !== '' && min_balance !== undefined && min_balance !== null) {
        url += `&min_balance=${min_balance}`;
    }
    return myFetch(null, url, { method: "GET" });
}